
import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';

export const FETCH_PLAYER_TICKET_REQUEST = 'FETCH_PLAYER_TICKET_REQUEST';
export const FETCH_PLAYER_TICKET_SUCCESS = 'FETCH_PLAYER_TICKET_SUCCESS';
export const FETCH_PLAYER_TICKET_FAILURE = 'FETCH_PLAYER_TICKET_FAILURE';

export const FETCH_TICKET_DETAILS_REQUEST = 'FETCH_TICKET_DETAILS_REQUEST';
export const FETCH_TICKET_DETAILS_SUCCESS = 'FETCH_TICKET_DETAILS_SUCCESS';
export const FETCH_TICKET_DETAILS_FAILURE = 'FETCH_TICKET_DETAILS_FAILURE';

const base_url = process.env.REACT_APP_API_URL_ADMIN;

export const getplayerTicketData = (startOfDay, endOfDay, userID, pageNo = 0) => async (dispatch) => {
  dispatch({ type: FETCH_PLAYER_TICKET_REQUEST });
  try {
    console.log(`user ${userID}  fdate ${startOfDay}  --- tDate ${endOfDay}`)
    const response = await axios.post(`${base_url}`, {
      apiName: 'ticket',
      command: 'getTicketByUserDate',
      userID: userID,
      startDate: startOfDay,
      endDate: endOfDay
    });
    console.log('response', response.data.data)
    dispatch({
      type: FETCH_PLAYER_TICKET_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PLAYER_TICKET_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch reporting data',
    });
  }
};


export const getTicketDetails = (ticketID) => async (dispatch) => {
  dispatch({ type: FETCH_TICKET_DETAILS_REQUEST });
  try {
    if (!ticketID) {
      dispatch({
        type: FETCH_TICKET_DETAILS_FAILURE,
        payload: 'Invalid Ticket ID',
      });
      return;
    }
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'ticket',
      command: 'getTicketDetails',
      ticket_id: ticketID,
      loggedInUserRole,
      loggedInUsername,
    });
    console.log('response', response.data)
    dispatch({
      type: FETCH_TICKET_DETAILS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_TICKET_DETAILS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch Ticket Details',
    });
  }
};
